export const POINTS_GIVEN_FOR_REVIEW = 100;
export const POINTS_GIVEN_FOR_REFER_A_FRIEND = '25,000';
